export default {
  translation: {
    shopButton: 'ZUM WARENKORB HINZUFÜGEN',
    buttonsHeader: 'ZUTATEN ONLINE KAUFEN',
    unavailableTitle: 'Leider liefern wir die Zutaten nicht an Ihre Adresse. Finden Sie Offline-Shops in Ihrer Nähe, in denen Sie unsere Produkte kaufen können.',
    unavailableButtonLabel: 'JETZT FINDEN'
  }
}
